import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { PropertyView } from 'ecs-react-components/dist/index.es';
import { messages } from './PatientInformation.i18n';
import { loadPatientRegistrationDetails } from '../../../redux/modules/account-settings/account-settings-middleware';
import { loadPatientIdentifierLabel } from '../../../redux/modules/localization/localization-middleware';

class PatientInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDemographicHeader: false,
      showContactInfoHeader: false,
      showOtherHeader: false,
    };
  }

  UNSAFE_componentWillMount() {
    if (this.props.patientId) {
      this.props.dispatch(loadPatientRegistrationDetails(this.props.patientId));
    }
    this.props.dispatch(loadPatientIdentifierLabel(this.props.language));
  }

  handleDemographicHeader = (shouldDisplay) => this.setState({ showDemographicHeader: shouldDisplay });
  handleContactInfoHeader = (shouldDisplay) => this.setState({ showContactInfoHeader: shouldDisplay });
  handleOtherHeader = (shouldDisplay) => this.setState({ showOtherHeader: shouldDisplay });

  render() {
    const { registrationDetails, patientIdentifierLabel } = this.props;
    if (Object.keys(registrationDetails).length > 0) {
      let clinicalTrialPrefix = '';
      if (registrationDetails.isClinicalTrial) {
        clinicalTrialPrefix = 'Yes - ';
      }
      return (
        <div className="settings-section">
            <h3><FormattedMessage { ...messages.title } /></h3>
            <div className="spacer medium"></div>
            <div className="row">
                <div className="col-sm-4">
                  <h4 className={ this.state.showDemographicHeader ? '' : 'hidden' }
                    data-qa-item="demographicsheader"
                  ><FormattedMessage { ...messages.subTitle.demographics } />
                  </h4>
                  <PropertyView label={ <FormattedMessage { ...messages.label.fullName } /> }
                    value={ registrationDetails.fullName }
                    qaTag="FullName"
                    handleHeaderDisplay={ this.handleDemographicHeader }
                  />
                  <PropertyView label={ patientIdentifierLabel }
                    value={ registrationDetails.mrn }
                    qaTag="MRN"
                    handleHeaderDisplay={ this.handleDemographicHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.gender } /> }
                    value={ registrationDetails.gender }
                    qaTag="Gender"
                    handleHeaderDisplay={ this.handleDemographicHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.dateOfBirth } /> }
                    value={ registrationDetails.dateOfBirthFormatted }
                    qaTag="DateOfBirth"
                    handleHeaderDisplay={ this.handleDemographicHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.birthCountry } /> }
                    value={ registrationDetails.birthCountry }
                    qaTag="BirthCountry"
                    handleHeaderDisplay={ this.handleDemographicHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.ethnicity } /> }
                    value={ registrationDetails.ethnicity }
                    qaTag="Ethnicity"
                    handleHeaderDisplay={ this.handleDemographicHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.race } /> }
                    value={ registrationDetails.race }
                    qaTag="Race"
                    handleHeaderDisplay={ this.handleDemographicHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.religion } /> }
                    value={ registrationDetails.religion }
                    qaTag="Religion"
                    handleHeaderDisplay={ this.handleDemographicHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.primaryLanguage } /> }
                    value={ registrationDetails.primaryLanguage }
                    qaTag="PrimaryLanguage"
                    handleHeaderDisplay={ this.handleDemographicHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.citizenship } /> }
                    value={ registrationDetails.citizenship }
                    qaTag="Citizenship"
                    handleHeaderDisplay={ this.handleDemographicHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.maritalStatus } /> }
                    value={ registrationDetails.maritalStatus }
                    qaTag="MartialStatus"
                    handleHeaderDisplay={ this.handleDemographicHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.mothersMaidenName } /> }
                    value={ registrationDetails.mothersMaidenName }
                    qaTag="MothersMaidenName"
                    handleHeaderDisplay={ this.handleDemographicHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.occupation } /> }
                    value={ registrationDetails.occupation }
                    qaTag="Occupation"
                    handleHeaderDisplay={ this.handleDemographicHeader }
                  />
                </div>
                <div className="col-sm-4">
                  <h4 className={ this.state.showContactInfoHeader ? '' : 'hidden' }
                    data-qa-item="contactinformationheader"
                  ><FormattedMessage { ...messages.subTitle.contactInformation } />
                  </h4>
                  <PropertyView label={ <FormattedMessage { ...messages.label.home } /> }
                    value={ registrationDetails.homePhoneNumberFormatted }
                    qaTag="HomePhoneNumber"
                    handleHeaderDisplay={ this.handleContactInfoHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.mobile } /> }
                    value={ registrationDetails.mobilePhoneNumberFormatted }
                    qaTag="MobilePhoneNumber"
                    handleHeaderDisplay={ this.handleContactInfoHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.primaryEmail } /> }
                    value={ registrationDetails.primaryEmail }
                    qaTag="PrimaryEmail"
                    handleHeaderDisplay={ this.handleContactInfoHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.preferredCommunication } /> }
                    value={ registrationDetails.preferredCommunication }
                    qaTag="PreferredCommunication"
                    handleHeaderDisplay={ this.handleContactInfoHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.address } /> }
                    value={ registrationDetails.address }
                    qaTag="Address"
                    handleHeaderDisplay={ this.handleContactInfoHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.address2 } /> }
                    value={ registrationDetails.address2 }
                    qaTag="Address2"
                    handleHeaderDisplay={ this.handleContactInfoHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.city } /> }
                    value={ registrationDetails.city }
                    qaTag="City"
                    handleHeaderDisplay={ this.handleContactInfoHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.state } /> }
                    value={ registrationDetails.state }
                    qaTag="State"
                    handleHeaderDisplay={ this.handleContactInfoHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.country } /> }
                    value={ registrationDetails.country }
                    qaTag="Country"
                    handleHeaderDisplay={ this.handleContactInfoHeader }
                  />
                </div>
                <div className="col-sm-4">
                  <h4 className={ this.state.showOtherHeader ? '' : 'hidden' }
                    data-qa-item="otherheader"
                  ><FormattedMessage { ...messages.subTitle.other } />
                  </h4>
                  <PropertyView label={ <FormattedMessage { ...messages.label.insurance } /> }
                    value={ registrationDetails.insurance }
                    qaTag="Insurance"
                    handleHeaderDisplay={ this.handleOtherHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.advanceDirective } /> }
                    value={ registrationDetails.advanceDirective }
                    qaTag="AdvanceDirective"
                    handleHeaderDisplay={ this.handleOtherHeader }
                  />
                  <PropertyView label={ <FormattedMessage { ...messages.label.clinicalTrial } /> }
                    value={ `${clinicalTrialPrefix}${registrationDetails.clinicalTrialID}` }
                    qaTag="ClinicalTrial"
                    handleHeaderDisplay={ this.handleOtherHeader }
                  />
                </div>
            </div>
        </div>
      );
    }
    return null;
  }
}
PatientInformation.propTypes = {
  dispatch: PropTypes.func.isRequired,
  patientId: PropTypes.number,
  registrationDetails: PropTypes.object,
  language: PropTypes.string,
  patientIdentifierLabel: PropTypes.string,

};

const mapStateToProps = (state) => ({
  patientId: state.profile.patient.patientId,
  registrationDetails: state.accountSettings.registrationDetails,
  patientIdentifierLabel: state.localization.patientIdentifierLabel,
  language: state.language.languageCode,
});

export default connect(mapStateToProps)(PatientInformation);